import type { QuickBooksControlCenterQuery } from '.';

export interface ControlCenterEventWorkspaceUnavailableError<
  Payload = EventWorkspaceAvailabilityPayload,
> {
  data: Payload;
  status: number;
  message: string;
}

type EventWorkspaceAvailabilityPayload = {
  currentState?: {
    available?: boolean;
    reasonCode?: string | null;
  } | null;
};

export const controlCenterEventWorkspaceUnavailableError = <
  Payload extends EventWorkspaceAvailabilityPayload,
>(
  workspace: Payload
): ControlCenterEventWorkspaceUnavailableError<Payload> | null => {
  if (workspace?.currentState?.available !== false) {
    return null;
  }
  const reasonCode =
    workspace.currentState.reasonCode || 'QB_CURRENT_STATE_UNAVAILABLE';
  return {
    status: 409,
    data: workspace,
    message: `Current event evidence is unavailable: ${reasonCode}`,
  };
};

export const controlCenterEventWorkspaceSearch = (
  query: QuickBooksControlCenterQuery
) => {
  const params = new URLSearchParams(
    Object.entries(query)
      .filter(
        ([key, value]) =>
          key !== 'cacheCompanyId' && value != null && value !== ''
      )
      .map(([key, value]) => [key, String(value)])
  );
  return params.toString();
};
